import { GET_SUB_CATEGORY_HELP_FAQ, GET_VENDOR_HELP_FAQ } from "../../types";

const initialState = {
  get_sub_category_help_faq: [],
  get_vendor_help_faq: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_SUB_CATEGORY_HELP_FAQ:
      return {
        ...state,
        get_sub_category_help_faq: payload,
      };
    case GET_VENDOR_HELP_FAQ:
      return {
        ...state,
        get_vendor_help_faq: payload,
      };
    default:
      return state;
  }
}
